import {
    FetchState,
  } from "@/shared/types";
  import {
    StateMachineState,
    StateMachineExecutionHistory
  } from "../types";
  import * as UserService from "@/shared/api/userService";
  import * as storeHelper from "@/shared/storeHelper";
  import { defineStore } from "pinia";
  import _ from "lodash";
  export const initialState: StateMachineState = {
    fetchState: FetchState.Uninitialized,
    stateMachineExecutionHistories: null
  };
  export const useStateMachineStore = defineStore("stateMachineStore", {
      state: (): StateMachineState => (_.cloneDeep(initialState)),
      getters: {
          isLoaded: state => state.fetchState === FetchState.Loaded,
          executionHistories: state => state.stateMachineExecutionHistories,
      },
      actions: {
          setFetchState (fetchState: FetchState) {
              this.fetchState = fetchState;
          },
          setMonitoredStateMachines (histories: StateMachineExecutionHistory[]) {
            this.stateMachineExecutionHistories = histories;
          },
          getMonitoredStateMachines (maxHistoryCount: number) {
            this.setFetchState(FetchState.Loading);
            return UserService.getMonitoredStateMachines(maxHistoryCount)
                .then(r => {
                    this.setMonitoredStateMachines(r.data);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
          },
      }
  });